<template>
  <div>
    <p style="font-size: 16px; margin-top: 5px">
      {{ leaveInfo.studentName }}提交的请假申请
    </p>
    <p style="font-size: 14px; margin-top: 5px">
      <span style="color: #909399">请假类型:</span>{{ leaveInfo.leaveType }}
    </p>
    <p style="font-size: 14px; margin-top: 5px">
      <span style="color: #909399">开始时间:</span>{{ leaveInfo.startTime }}
    </p>
    <p style="font-size: 14px; margin-top: 5px">
      <span style="color: #909399">结束时间:</span>{{ leaveInfo.endTime }}
    </p>
    <p style="font-size: 14px; margin-top: 5px">
      <span style="color: #909399">请假天数:</span>{{ leaveInfo.daysOff }}
    </p>
    <p style="font-size: 14px; margin-top: 5px">
      <span style="color: #909399">创建时间:</span>{{ leaveInfo.createTime }}
    </p>
    <p style="font-size: 14px; margin-top: 5px">
      <span style="color: #909399">请假状态:</span
      >{{ leaveInfo.status == 0 ? "未确认" : "已生效" }}
    </p>
    <van-divider :style="{ borderColor: '#303133', padding: '0 16px' }">
    </van-divider>
  </div>
</template>

<script>
export default {
  props: {
    leaveInfo: {
      type: Object,
      default: () => {
        return {
          startTime: "",
          startStr: "",
          endTime: "",
          endStr: "",
          daysOff: 1,
          leaveType: 1,
        };
      },
    },
  },
};
</script>

<style scoped>
</style>